// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-payment-css-PayInvoice__transitionReview--oowut{transition:all 1s cubic-bezier(0.175, 0.885, 0.32, 1.275)}`, "",{"version":3,"sources":["webpack://./src/payment/css/PayInvoice.scss"],"names":[],"mappings":"AAAA,qDACC,yDAAA","sourcesContent":[".transitionReview {\r\n\ttransition: all 1s cubic-bezier(0.175, 0.885, 0.32, 1.275)\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transitionReview": `src-payment-css-PayInvoice__transitionReview--oowut`
};
export default ___CSS_LOADER_EXPORT___;
